<script setup lang="ts">
import { SwitchButton } from '@element-plus/icons-vue';
import CusFooterBar from './components/CusFooterBar.vue';
import { useCommonStore } from '@/stores/modules/common';
import { ref, onMounted, onUnmounted, computed } from 'vue';
import Duel from './components/Duel.vue';
import { usePvpCardGameStore } from './services/gameService';
import Battle from './components/Battle.vue';
import Mall from './components/Mall.vue';
import Deck from './components/Deck.vue';
import { isTest } from './services/tools';
import BattleResult from './components/BattleResult.vue';
import Dungeon from './components/Dungeon.vue';
import Skill from './components/Skill.vue';
import BattleResultPve from './components/BattleResultPve.vue';
const commonStore = useCommonStore()
const pageState = ref('Duel')


const pvpCardGameStore = usePvpCardGameStore();

const pageList = [
  {
    name: 'Duel',
    component: Duel,
  },
  {
    name: 'Mall',
    component: Mall,
  },
  {
    name: 'Deck',
    component: Deck,
  },
  {
    name: 'Dungeon',
    component: Dungeon,
  },
  {
    name: 'Skill',
    component: Skill,
  },
]
let timer: number
onMounted(() => {
  clearTimeout(timer)
  pvpCardGameStore.connectLobby()
})

onUnmounted(() => {
  timer = window.setTimeout(() => {
    pvpCardGameStore.disconnectLobby()
  }, 60_000)
})



const showBattleIntro = ref(['connect'].includes(pvpCardGameStore.state))

function handleAnimationEnd(event: AnimationEvent) {
  if (event.target !== event.currentTarget) return;
  showBattleIntro.value = false
}

</script>
<template>
  <div class="pvp-card-page page">
    <template v-if="['idle', 'ready'].includes(pvpCardGameStore.state)">
      <div class="container">
        <component v-for="item of pageList" :key="item.name" :is="item.component" v-show="pageState === item.name">
          <template #top>
            <el-button class="exit-btn" type="danger" :icon="SwitchButton" size="small" plain circle
              @click="commonStore.path = 'Pub'" />
            <el-popover placement="top-end" width="240px" v-if="!isTest">
              <template #reference>
                <span
                  style="font-size: 12px;position: absolute;top: 20px;right: 20px;font-weight: normal;color: #f55;cursor: pointer;">删档测试
                </span>
              </template>
              <div class="affix">
                <p>1. 本轮为<b class="shrink">删档测试</b>。</p>
                <p>2. 测试结束后，将<b class="shrink">重置</b><span class="info">养成进度</span>，并<span class="grow">1比1</span>返还魂玉。
                </p>
              </div>
            </el-popover>
          </template>
        </component>
      </div>
      <CusFooterBar v-if="['idle'].includes(pvpCardGameStore.state)" v-model="pageState" />
    </template>
    <template v-else-if="['battle'].includes(pvpCardGameStore.state)">
      <Battle />
    </template>
    <BattleResult />
    <BattleResultPve />
    <div v-if="showBattleIntro" class="connecting battle-intro"
      :class="{ hidden: !['connect'].includes(pvpCardGameStore.state) }" @animationend="handleAnimationEnd">
      <div class="text zhanhun">战魂</div>
      <div class="text duijue">对决</div>
      <div class="text vs">VS</div>
      <div class="affix test" v-if="!isTest">
        <p>1. 本轮为<b class="shrink">删档测试</b>。</p>
        <p>2. 测试结束后，将<b class="shrink">重置</b><span class="info">养成进度</span>，并<span class="grow">1比1</span>返还魂玉。
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pvp-card-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.exit-btn {
  position: absolute;
  top: 10px;
  left: 20px;
}

.container {
  flex: 1;
  overflow: hidden;
}

.connecting {

  &.hidden {
    animation: fadeOut 0.8s 1.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards;
  }

  .test {
    font-size: 14px;
    text-align: left;
    position: fixed;
    bottom: 20px;
    z-index: 2000;
  }

}
</style>
<style lang="scss">
.pvp-card-page {
  .normal {
    color: #59b;
  }
}
</style>

<style lang="scss">
.battle-intro {
  background: #141414;
  color: white;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1999;

  .text {
    font-size: 5rem;
    font-weight: bold;
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    opacity: 0;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.7);
    white-space: nowrap;
  }

  .zhanhun {
    left: -300px;
    color: #ff3366;
    animation: slideInLeft 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards;
  }

  .duijue {
    right: -300px;
    color: #33ccff;
    animation: slideInRight 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards;
  }


  .vs {
    font-size: 8rem;
    color: white;
    opacity: 0;
    z-index: 10;
    text-shadow: 0 0 20px #ff00aa, 0 0 30px #ff00aa;
    animation: vsPop 0.6s 0.8s ease-out forwards;
  }



  @keyframes slideInLeft {
    to {
      left: 50%;
      transform: translateX(-100%) translateY(-50%);
      opacity: 1;
    }
  }

  @keyframes slideInRight {
    to {
      right: 50%;
      transform: translateX(100%) translateY(-50%);
      opacity: 1;
    }
  }

  @keyframes vsPop {
    0% {
      transform: scale(0.2) rotate(-30deg);
      opacity: 0;
    }

    70% {
      transform: scale(1.2) rotate(5deg);
      opacity: 1;
    }

    100% {
      transform: scale(1) rotate(0);
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
}
</style>